export default "__VITE_ASSET__Dqd$OwYY__"